// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireConditionIsNotEmptyFragmentDoc = gql`
    fragment questionnaireConditionIsNotEmpty on QuestionnaireConditionIsNotEmpty {
  __typename
  question {
    id
  }
}
    `;